enum ActionName {
    CREATE_USER = 'CreateUser',
    EDIT_USER = 'EditUser',
    DELETE_USER = 'DeleteUser',
    CHANGE_USER_ACTIVE_STATUS = 'ChangeUserActiveStatus',
    CHANGE_USER_ROLE = 'ChangeUserRole',
    CHANGE_USER_AUTH_TYPE = 'ChangeUserAuthType',
    CHANGE_ASSIGN_SHIPPER = 'ChangeAssignShipper',
    CHANGE_REMOVE_SHIPPER = 'ChangeRemoveShipper',
    CHANGE_ASSIGN_SHIPPER_WILDCARD = 'ChangeAssignShipperWildCard',
    CHANGE_ASSIGN_LOCATION_WILDCARD = 'ChangeAssignLocationWildCard',
    SEE_CORE_REGION_USERS = 'SeeCoreRegionUsers',
    VIEW_SHIPPER = 'ViewShipper',
    CHANGE_SHIPPER = 'ChangeShipper',
    TIMEOUTS_LVR = 'TimeoutsLVR',
    TIMEOUTS_CBR = 'TimeoutsCBR',
    TIMEOUTS_SSR = 'TimeoutsSSR',
    TIMEOUTS_CCO = 'TimeoutsCCO',
    TIMEOUTS_ISRS = 'TimeoutsISRS',
    TIMEOUTS_IT = 'TimeoutsIT',
    ROUTING_STRATEGY = 'RoutingStrategy',
    REAL_SHIPPER_ALLOWED = 'RealShipperAllowed',
    TRACK_ID_INJECTION = 'TrackIdInjection',
    ONBOARDING = 'Onboarding'
}

export default ActionName;
